// src/components/game/GameControls.js - Güncellenmiş (Logsuz)
import React from 'react';
import { INITIAL_CELLS } from '../../constants/gameConstants';

export const GameControls = React.memo(({
    gameState,
    isSetupPhase,
    isMyTurn,
    selectedSetupCells,
    selectedCell,
    currentTurnPlayer,
    canPerformAttack,
    handleConfirmSetup,
    handleExpand,
    handleAttack,
    handleEndTurn,
    handleLeaveGame,
    myPlayerIndex
}) => {
    
    // Log referansı ve useEffect kaldırıldı çünkü log artık burada değil.

    if (!gameState) return null;

    return (
        <div className="glass-panel rounded-xl p-3 flex flex-col border-opacity-20 shadow-xl h-auto">
            {/* HEADER */}
            <h3 className="text-slate-200 text-xs font-bold flex items-center gap-1.5 tracking-wide uppercase border-b border-slate-700/50 pb-2 mb-2">
                <span className="text-sm">🎮</span> Kontrol
            </h3>

            {/* BUTONLAR */}
            <div className="flex-shrink-0 mb-2 space-y-2">
                {isSetupPhase ? (
                    <div className="space-y-1.5">
                        <div className="text-xs text-slate-400">
                            Seçilen: <span className={selectedSetupCells.length === INITIAL_CELLS ? "text-emerald-400 font-bold" : "text-yellow-400"}>
                                {selectedSetupCells.length}/{INITIAL_CELLS}
                            </span>
                        </div>
                        <button
                            onClick={handleConfirmSetup}
                            disabled={!isMyTurn || selectedSetupCells.length !== INITIAL_CELLS}
                            className={`w-full py-2 rounded-lg text-xs font-bold transition-all ${
                                !isMyTurn || selectedSetupCells.length !== INITIAL_CELLS
                                    ? 'bg-slate-800 text-slate-500 cursor-not-allowed'
                                    : 'bg-emerald-600 hover:bg-emerald-500 text-white shadow-lg active:scale-95'
                            }`}
                        >
                            {isMyTurn ? "ONAYLA" : "Sıra Bekle..."}
                        </button>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 gap-1.5">
                        <button
                            onClick={handleExpand}
                            disabled={!isMyTurn || !selectedCell?.target || gameState.hasExpanded}
                            className={`p-2 rounded-lg text-xs font-bold transition-all ${
                                !isMyTurn || !selectedCell?.target || gameState.hasExpanded
                                    ? 'bg-slate-800/50 text-slate-600'
                                    : 'bg-blue-600 hover:bg-blue-500 text-white shadow-md active:scale-95'
                            }`}
                        >
                            📦 Genişle
                        </button>

                        <button
                            onClick={handleAttack}
                            disabled={!isMyTurn || !selectedCell?.target || !canPerformAttack()}
                            className={`p-2 rounded-lg text-xs font-bold transition-all ${
                                !isMyTurn || !selectedCell?.target || !canPerformAttack()
                                    ? 'bg-slate-800/50 text-slate-600'
                                    : 'bg-red-600 hover:bg-red-500 text-white shadow-md active:scale-95'
                            }`}
                        >
                            ⚔️ Saldır
                        </button>

                        <button
                            onClick={handleEndTurn}
                            disabled={!isMyTurn}
                            className={`col-span-2 py-2 rounded-lg text-xs font-bold transition-all ${
                                !isMyTurn
                                    ? 'bg-slate-800/50 text-slate-600'
                                    : 'bg-amber-600 hover:bg-amber-500 text-white shadow-md active:scale-95'
                            }`}
                        >
                            {isMyTurn ? "🏁 TUR BİTİR" : `${currentTurnPlayer?.name} oynuyor`}
                        </button>
                    </div>
                )}
            </div>

            {/* LOG KISMI KALDIRILDI - Artık sol panelde */}

            {/* ÇIKIŞ */}
            <button
                onClick={handleLeaveGame}
                className="mt-2 w-full py-1.5 rounded-lg border border-red-500/20 text-red-400 hover:bg-red-500/10 hover:text-red-300 text-[10px] font-bold transition-colors"
            >
                🚪 OYUNDAN AYRIL
            </button>
        </div>
    );
});